export default __webpack_public_path__ + "static/media/Sunset-Turbines-Narrow-3840px-1440px-web.jpg.ef88e67e.webp";